import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  mixins: [ActionsForm],
  name: 'modalRequests',
  props: {
    id: {
      type: String,
      default: null
    },
    request: {
      type: Object,
      default: {}
    },
    selectedSolicitacao: {}
  },
  data () {
    return {
      popupPage: 1,
      pendencia: '',
      requestsRepproved: []
    }
  },
  mounted () {
    RequestsRepository.GetSolicitacoesReprovadas(this.id)
      .then(res => {
        this.requestsRepproved = res.data.data
      })
      .catch(() => {})
  },
  methods: {

    onLoad () {

    },
    close () {
      this.$root.$emit('bv::hide::modal', 'RequestModal')
      this.popupPage = 1
    },

    approve (id) {
      this.popupPage = 2
    },

    disapprove () {
      this.popupPage = 3
    },

    pendency () {
      this.popupPage = 4
    },

    voltar () {
      this.popupPage = 1
    },

    approveRequest (id) {
      loading.push()
      this.$root.$emit('bv::hide::modal', 'RequestModal')
      RequestsRepository.AprovarSolicitacao(id)
        .then(res => {
          if (res.data.code === -400) {
            toast.error(res.data.message)
            loading.pop()
            return
          }
          document.location.reload()
        })
        .catch(() => {})
    },

    resolvePending (id) {
      loading.push()
      RequestsRepository.ResolverPendenciasAprovacao(id)
        .then(res => {
          if (res.data.code === 200) {
            toast.success('Solicitação aprovada com sucesso')
            loading.pop()
            setTimeout(() => {
              document.location.reload()
            }, 1000)
          }
        })
        .catch(() => {
          toast.error('Ocorreu um erro durante a aprovação do usuário')
          loading.pop()
        })
    },

    repproveRequest (id, pendencia) {
      let data = {
        pendencia: pendencia
      }
      this.request.status = 1
      RequestsRepository.ReprovarSolicitacao(id, data)
        .then(res => {
          this.$root.$emit('bv::hide::modal', 'RequestModal')
          document.location.reload()
        })
        .catch(() => {})
    },
    pendencyRequest (id, pendencia) {
      let data = {
        pendencia: pendencia
      }
      if (pendencia !== '') {
        RequestsRepository.PendenciaDeSolicitacao(id, data)
          .then(res => {
            this.$root.$emit('bv::hide::modal', 'RequestModal')
            document.location.reload()
          })
          .catch(() => {})
      } else {
        toast.error('Pendência não adicionada, adicione uma observação')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/modalRequest/modalRequest.js